<table class="timeline">
  <tbody>
  <tr *ngFor="let event of events; first as isFirst; last as isLast; index as index">

    <!-- Non-core events are intentionally hidden from the timeline. They are
         still present in the API response but are never rendered.
         To restore the previous "Show N more events" reveal behaviour, swap the
         condition below back to the commented-out original and re-enable the
         "Event hidden" message block + the revealEvents/countHiddenEvents
         methods in timeline.component.ts. -->
    <!-- <ng-container *ngIf="event.coreEvent || isFirst || events[index-1].coreEvent"> -->
    <ng-container *ngIf="event.coreEvent">

      <!-- Left-side labels -->
      <td class="text-end pe-4 d-flex flex-column mb-5">
        <ng-container *ngIf="event.coreEvent">
          <div class="label">{{getEventCity(event)}}</div>
          <div class="value">{{getEventCountry(event)}}</div>
          <div class="value facility-name" *ngIf="getEventFacilityName(event)">{{getEventFacilityName(event)}}</div>
          <div class="value unlocode" *ngIf="getEventUNLocationCode(event)">{{getEventUNLocationCode(event)}}</div>
          <div class="value left-label-placeholder" *ngIf="hasNoLocationInfo(event)">No location information to show</div>
        </ng-container>
      </td>


      <!-- Icon / show more events message -->
      <td class="text-center align-text-top position-relative">

        <!-- Background - top half -->
        <!-- Draw the upper line only when a visible (core) event precedes this
             one, so the first visible event never shows a stray line above it. -->
        <div
          class="position-absolute w-100 top-half"
          [class.active-line]="hasCoreEventBefore(index) && !isMuted(index)"
          [class.disabled-line]="hasCoreEventBefore(index) && isMuted(index)">
          &nbsp;
        </div>

        <!-- Background - bottom half -->
        <!-- Draw the lower line only when a visible (core) event follows this one. -->
        <div class="position-absolute w-100 bottom-half"
             [class.active-line]="hasCoreEventAfter(index) && (!isMuted(index) && !isMuted(index+1))"
             [class.disabled-line]="hasCoreEventAfter(index) && (isMuted(index) || isMuted(index+1))">
          &nbsp;
        </div>

        <!-- div which contains the actual icon -->
        <!-- position-relative is necessary so that the z-indexing works as expected -->
        <div
          class="position-relative"
          *ngIf="event.coreEvent"
          [class.active-icon]="!isMuted(index)"
          [class.disabled-icon]="isMuted(index)">
          <svg width="36" height="36" class="mt-3 timeline-icon">
            <use [attr.href]="'/assets/icons.svg#'+computeIcon(event)"></use>
          </svg>
        </div>

        <!-- "Event hidden" message — disabled: non-core events are no longer shown.
        <div *ngIf="!event.coreEvent" class="event-hidden-container">
          <div class="event-hidden-message" (click)="revealEvents(index)">
            Show {{countHiddenEvents(index)}} more
            {{countHiddenEvents(index) > 1 ? 'events' : 'event'}}
          </div>
        </div>
        -->
      </td>

      <!-- Details -->
      <td class="ps-4 d-flex flex-column mb-5">
        <ng-container *ngIf="event.coreEvent">
          <div class="value fw-bold">{{getLocalTime(event.eventDateTime) | date:'dd-MMM-yyyy HH:mm'}}</div>
          <div class="value text-capitalize-first-letter">{{event.eventLegibleName}}</div>
        </ng-container>
      </td>
    </ng-container>
  </tr>
  </tbody>
</table>
